import script from "./billing-address-page.vue?vue&type=script&setup=true&lang=ts"
export * from "./billing-address-page.vue?vue&type=script&setup=true&lang=ts"

import "./billing-address-page.vue?vue&type=style&index=0&id=4fcae6a4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fcae6a4"]])

export default __exports__